import React, { memo } from 'react';
import { convertAmount } from '@pascal/pascal-core';

export const BetAmountsBlock = memo(
  ({ handleQuickBet, index: candyIndex, amount, activeFreeBet, quickBets, betAmountBlockRef }) => {
    return (
      <div className='amount-block-wrapper' ref={betAmountBlockRef}>
        {activeFreeBet.id ? (
          <p
            className={`amount-block-row ${amount === activeFreeBet.amount ? 'active' : ''}`}
            onClick={() => handleQuickBet({ quickBet: activeFreeBet.amount, index: candyIndex })}
          >
            {convertAmount(activeFreeBet.amount)}
          </p>
        ) : (
          quickBets
            ?.sort((a, b) => b - a)
            .map((quickBet, index) => (
              <p
                className={`amount-block-row ${amount === quickBet ? 'active' : ''}`}
                key={quickBets + index}
                onClick={() => handleQuickBet({ quickBet, index: candyIndex })}
              >
                {convertAmount(quickBet)}
              </p>
            ))
        )}
      </div>
    );
  }
);
